import { AlignContent } from './helpers/AlignContent';
import { CircularProgress, makeStyles } from '@material-ui/core';
import React from 'react';
import { Colors } from '../constants/colors';

const useStyles = makeStyles({
  loading: {
    color: Colors.primary,
    marginTop: '40px'
  }
});

export const Loading = ({ show }: { show: boolean }) => {
  const classes = useStyles();

  if (!show) {
    return null;
  }

  return <AlignContent to='center'
                       className={classes.loading}>
    <h3>Načítáme data...</h3>
    <CircularProgress />
  </AlignContent>;
};
